import { HttpHeaders, HttpParams } from '@angular/common/http';

import { ApiStatus } from '../../models/api-status.model';
import { SearchResult } from '../service-locator/service-locator.models';

export interface AutocompleteRequest {
  types: string;
  input: string;
  radius?: string;
  location?: string; // formatted as lat/lng number values: eg.
}

export interface GeoCoderState {
  loading: boolean;
  userSelectedChoice: string;
  fullAddress: FullAddressDetails;
  predictions: Prediction[];
  selectedShop?: SearchResult;
  error?: any;
}

export interface Prediction {
  description: string;
  place_id: string;
}

export interface FullAddressDetails {
  formatted_address: string;
  address_line1: string;
  city: string;
  stateCode: string;
  Country: string;
  zip: string;
  lat?: string;
  long?: string;
}

export interface HttpOptions {
  params: HttpParams;
  headers?: HttpHeaders;
}

export interface ParseDetails {
  addressDetail: AddressDetail;
  status: ApiStatus;
}

export interface MatchedlocationsDetails {
  addressMatchDetail: AddressMatchDetail;
  matchedCities: MatchedCities[];
  status: ApiStatus;
}
export interface AddressMatchDetail {
  exactAddressMatchIndicator: boolean;
  multipleAddressMatchIndicator: boolean;
}
export interface MatchedCities {
  city: string;
  state: string;
  zip5: string;
  cityShortName: string;
  uspsCityType: string;
}

export interface AddressDetail {
  address: AddressDetails;
  addressDetail: AddressDetail;
  locationMatchDetail: LocationMatchDetail;
}

export interface AddressDetails {
  line1: string;
  line2: string;
  city: string;
  state: string;
  zip5: string;
  zip4: string;
  countryIdentifier: string;
}
export interface LocationMatchDetail {
  amfamMatchCode: string;
  amfamProductCode: string;
  geoConfidenceCode: string;
  geocoderMatchCode: string;
  locationCode: string;
  locationDescription: string;
  matchCode: string;
  matchCodeDescription: string;
  matchConfidence: string;
  matchScore: string;
  matchStatusCode: string;
  matchStatusDescription: string;
  matchStatusReason: string;
  streetDataCode: string;
}

export const initialGeoCoderState: GeoCoderState = {
  loading: false,
  userSelectedChoice: '',
  fullAddress: null,
  predictions: []
};
